import { render, staticRenderFns } from "./queueManangement.vue?vue&type=template&id=50b4b850&scoped=true&"
import script from "./queueManangement.vue?vue&type=script&lang=js&"
export * from "./queueManangement.vue?vue&type=script&lang=js&"
import style0 from "./queueManangement.vue?vue&type=style&index=0&id=50b4b850&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4b850",
  null
  
)

export default component.exports